/*
 * /chat (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Divider, Page, PageHeader } from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { v4 as uuidv4 } from "uuid"
import { ChatRoomList } from "../../features/chat/components/chat-room-list"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/chat/")({
	component: ChatsPage,
	loader: authPageLoader,
})

enum ChatRoomTypeEnum {
	AI = "ai",
	Direct = "direct",
	Group = "group",
	Channel = "channel",
}

function ChatsPage() {
	const { user } = Route.useLoaderData()

	const { data: chatRooms, isLoading } = trpc.chatRoom.getAllByFilter.useQuery({
		sort: { column: "createdAt", direction: "desc" },
		where: { userId: user?.id ?? "", roomPurpose: "%psychology%" },
	})

	// let newChatParams = "type=session"
	// if (chatRooms.data?.length === 0) {
	// 	newChatParams = "type=introduction"
	// }

	console.log("Chats", { chatRooms, isLoading })
	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Chats"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<div className={"flex size-full flex-1 flex-col"}>
					<ChatRoomList
						newId={uuidv4()}
						roomType={ChatRoomTypeEnum.AI}
						initialChatRooms={chatRooms || []}
						pathPrefix={"/chat"}
					/>
				</div>
			</Container>
		</Page>
	)
}
